import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonSharedModule, HelpModule} from 'common-shared';
import {RouterModule} from '@angular/router';
import {UserSelectComponent} from './user/user-select/user-select.component';
import {UserEditModalComponent} from './user/user-edit-modal/user-edit-modal.component';
import {UserEditComponent} from './user/user-edit/user-edit.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {RoleSelectComponent} from './role/role-select/role-select.component';
import {RoleEditComponent} from './role/role-edit/role-edit.component';
import {RoleEditModalComponent} from './role/role-edit-modal/role-edit-modal.component';
import {InlineSVGModule} from "ng-inline-svg-2";
import {EditModalButtonsComponent} from "../components/edit-modal/edit-modal-buttons/edit-modal-buttons.component";
import {TranslocoModule} from "@jsverse/transloco";
import {TableModule} from "primeng/table";
import {NgArrayPipesModule} from "ngx-pipes";
import {UserHasPrivilegePipe} from "./user/user-has-privilege.pipe";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    CommonSharedModule,
    InlineSVGModule,
    TranslocoModule,
    TableModule,
    NgArrayPipesModule,
    UserHasPrivilegePipe,
    HelpModule
  ],
  exports: [
    UserSelectComponent,
    RoleSelectComponent,
    UserEditModalComponent,
    EditModalButtonsComponent,
    UserEditComponent
  ],
  declarations: [
    UserSelectComponent,
    UserEditModalComponent,
    UserEditComponent,
    RoleSelectComponent,
    RoleEditComponent,
    RoleEditModalComponent,
    EditModalButtonsComponent
  ]
})
export class SystemModule {
}
